/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IFriendEntryResponse } from './IFriendEntryResponse';
import {
    IFriendEntryResponseFromJSON,
    IFriendEntryResponseFromJSONTyped,
    IFriendEntryResponseToJSON,
    IFriendEntryResponseToJSONTyped,
} from './IFriendEntryResponse';

/**
 * Friends list API response
 * @export
 * @interface IFriendsListResponse
 */
export interface IFriendsListResponse {
    /**
     * 
     * @type {string}
     * @memberof IFriendsListResponse
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof IFriendsListResponse
     */
    odId?: string;
    /**
     * 
     * @type {Array<IFriendEntryResponse>}
     * @memberof IFriendsListResponse
     */
    friends?: Array<IFriendEntryResponse>;
    /**
     * 
     * @type {number}
     * @memberof IFriendsListResponse
     */
    pendingReceivedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof IFriendsListResponse
     */
    blockedCount?: number;
    /**
     * 
     * @type {number}
     * @memberof IFriendsListResponse
     */
    friendCount?: number;
    /**
     * 
     * @type {number}
     * @memberof IFriendsListResponse
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof IFriendsListResponse
     */
    updatedAt?: number;
}

/**
 * Check if a given object implements the IFriendsListResponse interface.
 */
export function instanceOfIFriendsListResponse(value: object): value is IFriendsListResponse {
    return true;
}

export function IFriendsListResponseFromJSON(json: any): IFriendsListResponse {
    return IFriendsListResponseFromJSONTyped(json, false);
}

export function IFriendsListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFriendsListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'odId': json['odId'] == null ? undefined : json['odId'],
        'friends': json['friends'] == null ? undefined : ((json['friends'] as Array<any>).map(IFriendEntryResponseFromJSON)),
        'pendingReceivedCount': json['pendingReceivedCount'] == null ? undefined : json['pendingReceivedCount'],
        'blockedCount': json['blockedCount'] == null ? undefined : json['blockedCount'],
        'friendCount': json['friendCount'] == null ? undefined : json['friendCount'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
    };
}

export function IFriendsListResponseToJSON(json: any): IFriendsListResponse {
    return IFriendsListResponseToJSONTyped(json, false);
}

export function IFriendsListResponseToJSONTyped(value?: IFriendsListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'odId': value['odId'],
        'friends': value['friends'] == null ? undefined : ((value['friends'] as Array<any>).map(IFriendEntryResponseToJSON)),
        'pendingReceivedCount': value['pendingReceivedCount'],
        'blockedCount': value['blockedCount'],
        'friendCount': value['friendCount'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
    };
}

